import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { navigateToRoute } from '../../../../redux_store';
import MenuItem from '../../../Shared/Table/widgets/MenuItem';
import { ReactComponent as EditIcon } from '../../../../assets/icons/edit.svg';
import { ReactComponent as RemoveIcon } from '../../../../assets/icons/remove.svg';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import { ALL_ROUTES } from '../../../../config/routes';

const TableActions = ({
  row,
  setAnchorEl,
  onDeleteUser,
}) => {
  const {
    en: {
      titles,
    },
  } = useSelector((state) => state.i18n);

  const handleDeleteUser = (e, userData) => {
    // Placeholder for delete user functionality
    // Will be implemented later
    if (onDeleteUser) {
      onDeleteUser(userData);
    }
    setAnchorEl(null);
  };

  const actions = [
    {
      key: 'delete-user',
      icon: <RemoveIcon />,
      onActionClick: handleDeleteUser,
      children: titles.deleteUser || 'Delete User',
      isRemove: true,
      addDivider: false,
    },
  ];

  const children = useMemo(
    () => actions.map((props) => {
      const { key, children, onActionClick, icon, addDivider, isRemove } = props;
      return (
        <MenuItem
          key={key}
          title={children}
          icon={icon}
          setAnchorEl={setAnchorEl}
          onClick={(e) => onActionClick(e, row.original)}
          hasTopDriver={addDivider}
          isErrorStyle={isRemove}
        />
      );
    }),
    [row, setAnchorEl]
  );

  return <>{children}</>;
};

export default TableActions;
